<template>
  <div class="menu-option">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong class="first">
                <h3>
                  <router-link :to="{ name: 'menu_list'}" class="float-left mr-1 main-link">{{$t('menu.menus')}}</router-link>
                  <span class="float-left mr-1 main-link">/</span>
                  <router-link :to="{ name: 'menu_edit',  params: { id: id }}" class="float-left mr-1 main-link">{{$t('menu.detail')}}</router-link>
                  / {{$t('menu.crust_size_detail')}}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <strong class="uppercase">{{ $t('menu.crust_size_detail') }}</strong>
        </div>
        <b-row>
          <b-col cols="12" v-if="single.config.more_first">
            <span class="btn text-main" @click="addSingleFirst">
              <i class="fa fa-plus-circle"></i> {{$t('common.add_more')}}
            </span>
          </b-col>
          <b-col cols="12">
            <b-form>
              <draggable :disabled="!enabled" class="list-group" ghost-class="ghost" v-model="first_layers" group="pizza-first" draggable=".list-first" @start="isDragging=true" @end="isDragging=false">
                <div class="option-box" :class="groupSizeShow[f] ? '' : 'list-first' " v-for="(first, f) in first_layers" :key="first.id">
                  <div class="option-first">
                    <b-row>
                      <b-col cols="4" class="d-flex adjustment-padding-5">
                        <div class="size-label">{{$t('menu.size')}}</div>
                        <div v-for="lang in $store.getters.languages" :key="lang.id" class="size-name-input">
                          <b-form-input autocomplete="off" :list="'name_first_layer_list_' +lang + '_' + f" type="text" class="form-control" @change="updateFirstLayerItems(f , $event, lang)" v-model="first_layers[f].name[lang]" v-bind:placeholder="$t('common.text_'+lang)"></b-form-input>
                          <datalist :id="'name_first_layer_list_' + lang + '_' + f" v-if="first_layer_options.length > 0">
                            <option v-for="(first_option, o) in first_layer_options" :key="first_option.sku + o" v-bind:value="first_option.name[lang]"  v-bind:label="first_option.name[lang]"></option>
                          </datalist>
                        </div>
                      </b-col>

                      <b-col cols="2" class="d-flex adjustment-padding-5">
                        <div class="size-label">{{$t('menu.code')}}</div>
                        <div class="size-code-input">
                          <b-form-input autocomplete="off" :list="'sku_first_layer_list_'+ '_' + f" type="text" class="form-control" @change="updateFirstLayerItems(f , $event)"  v-model="first_layers[f].sku"/>
                          <datalist :id="'sku_first_layer_list_'+  '_' + f" v-if="first_layer_options.length > 0">
                            <option v-for="(first_option, o) in first_layer_options" :key="first_option.sku + o" v-bind:value="first_option.sku"  v-bind:label="first_option.sku" ></option>
                          </datalist>
                        </div>
                      </b-col>

                      <b-col cols="2" class="d-flex adjustment-padding-5" v-show="single.config.first_price">
                        <div class="size-label">{{$t('menu.price')}} (¥)</div>
                        <div class="size-price-input" v-if="_.size(tier) <= 1 && single.config.first_multi_price != true && single.config.product_tax_price != true">
                          <div class="full-width" v-for="(price, p) in first_layers[f].prices" :key="price.id">
                            <input type="hidden" class="form-control" v-model="first_layers[f].prices[p].active"/>
                            <input type="hidden" class="form-control" v-model="first_layers[f].prices[p].from"/>
                            <input type="hidden" class="form-control" v-model="first_layers[f].prices[p].to"/>
                            <input type="hidden" class="form-control" v-model="first_layers[f].prices[p].tax_rate"/>
                            <div v-for="(name, index) in tier" class="full-width">
                              <b-form-input type="number" min="0" class="form-control" v-model="first_layers[f].prices[p].price[index]" v-bind:placeholder="$t('menu.price')" :disabled="checkDisableByConfig('first', 'price')">
                              </b-form-input>
                              <input type="hidden" class="form-control" v-model="first_layers[f].prices[p].price_without_tax[index]"/>
                            </div>
                          </div>
                        </div>
                        <div class="size-price-input" v-if="_.size(tier) > 1 || single.config.first_multi_price == true || single.config.product_tax_price == true">
                          <button type="button" class="btn bg-main border-radius-4px" v-on:click="showModal('first_'+f)">
                            {{$t('menu.edit_price')}}
                          </button>
                          <!-- the prices modal -->
                          <b-modal :id="'first_'+f" centered :title="$t('menu.price')">
                            <div class="row" v-if="single.config.first_multi_price">
                              <div class="col-sm-12 mb-2 text-main">
                                <span class="button-text" @click="addPriceToSingeFirst(f)"><i class="fa fa-plus"></i> {{$t('common.add')}}</span>
                              </div>
                            </div>

                            <div class="full-width" v-for="(price, p) in first_layers[f].prices" :key="price.id">
                              <input type="hidden" class="form-control" v-model="first_layers[f].prices[p].active"/>
                              <div class="row bg-secondary py-2 d-flex" v-if="single.config.first_multi_price">
                                <div class="d-flex flex-1 px-3">
                                  <div class="size-label">{{$t('menu.from')}}</div>
                                  <div class="size-code-input">
                                    <masked-input
                                      type="text"
                                      name="date"
                                      class="form-control"
                                      v-model="first_layers[f].prices[p].from"
                                      :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                      :guide="true"
                                      placeholderChar="_"
                                      :showMask="true"
                                      :keepCharPositions="true">
                                    </masked-input>
                                  </div>
                                </div>
                                <div class="d-flex flex-1 px-3">
                                  <div class="size-label text-right">{{$t('menu.to')}}</div>
                                  <div class="size-code-input">
                                    <masked-input
                                      type="text"
                                      name="date"
                                      class="form-control"
                                      v-model="first_layers[f].prices[p].to"
                                      :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                      :guide="true"
                                      placeholderChar="_"
                                      :showMask="true"
                                      :keepCharPositions="true">
                                    </masked-input>
                                  </div>
                                </div>
                                <div class="auto-width px-3 button-text" v-if="single.config.first_multi_price">
                                  <i class="fa fa-trash-o text-main" @click="removePriceToSingeFirst(f, p)"></i>
                                </div>
                              </div>

                              <div class="row py-2">
                                <div class="col-sm-12" v-if="single.config.product_tax_price">
                                  <b-form-group v-bind:label="$t('menu.tax_rate')">
                                    <input type="number" class="form-control" v-model="first_layers[f].prices[p].tax_rate"/>
                                  </b-form-group>
                                </div>
                                <div class="col-sm-6 d-flex mb-0" v-for="(name, index) in tier">
                                  <b-card class="pb-0" v-bind:title="name ? name : $t('menu.tier') + ' ' + index">
                                    <b-form-group>
                                      <b-row>
                                        <div class="col-sm-12">
                                          <b-form-group v-bind:label="$t('menu.price')">
                                            <b-form-input type="number" min="0" class="form-control" v-model="first_layers[f].prices[p].price[index]" v-bind:placeholder="$t('menu.price')" :disabled="checkDisableByConfig('first', 'price')">
                                            </b-form-input>
                                          </b-form-group>
                                        </div>
                                        <div class="col-sm-12" v-if="single.config.product_tax_price">
                                          <b-form-group v-bind:label="$t('menu.price_without_tax')">
                                            <input type="number" class="form-control" v-model="first_layers[f].prices[p].price_without_tax[index]"/>
                                          </b-form-group>
                                        </div>

                                      </b-row>
                                    </b-form-group>
                                  </b-card>
                                </div>
                              </div>
                            </div>
                            <div slot="modal-footer" class="full-width">
                              <button type="button" class="btn bg-main float-right border-radius-4px" v-on:click="hideModal('first_'+f)">{{$t('common.save')}}</button>
                            </div>
                          </b-modal>
                          <!-- end the prices modal -->
                        </div>
                      </b-col>

                      <b-col cols="1" class="size-active adjustment-padding-5">
                        <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="first_layers[f].active" :value="1" :uncheckedValue="0"/>
                      </b-col>

                      <b-col cols="1" class="adjustment-padding-5"  v-if="single.config.more_second">
                        <button type="button" class="btn bg-main border-radius-4px full-width pl-5px pr-5px" v-on:click="addSingleSecond(f)">
                          <i class="fa fa-plus"></i> {{$t('menu.crust')}}
                        </button>
                      </b-col>

                      <b-col cols="1" class="size-remove adjustment-padding-5" v-if="single.config.more_first">
                        <i class="fa fa-trash-o text-main" v-on:click="removeSingeFirst(f)"></i>
                      </b-col>

                      <b-col cols="1" class="size-remove adjustment-padding-5">
                        <button type="button" class="btn btn-md border-radius-4px bg-main btn-primary" @click="updateGroupSizeShow($event,f)">
                          <i class="fa fa-angle-up" v-if="groupSizeShow[f]"></i>
                          <i class="fa fa-angle-down" v-if="!groupSizeShow[f]"></i>
                        </button>
                      </b-col>

                    </b-row>
                  </div>
                  <b-collapse v-model="groupSizeShow[f]" :id="'combo-group-size-' + f">
                    <div class="option-second">
                      <draggable :disabled="!enabled" :group="{name: 'pizza-second', put: true, pull: false}" class="row" ghost-class="ghost" v-model="first_layers[f].second_layers" draggable=".list-second"  @start="isDragging=true" @end="isDragging=false">
                        <div class="col-lg-4 col-md-6 list-second" v-for="(second, s) in first_layers[f].second_layers" :key="second.id">
                          <div class="second-box">
                            <div class="second-header">
                              <span class="text-main font-weight-600 hide">{{$t('menu.crust')}} {{s + 1}}</span>
                              <span>
                                <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="first_layers[f].second_layers[s].active" :value="1" :uncheckedValue="0"/>
                              </span>
                              <span class="close-btn" @click="removeSingeSecond(f, s)" v-if="single.config.more_second">
                                <i class="fa fa-trash-o text-main"></i>
                              </span>
                            </div>
                            <b-form-group v-for="lang in $store.getters.languages" label-class="hidden" :key="lang.id">
                              <b-form-input autocomplete="off" :list="'name_second_layer_list_' + lang + '_' + f + '_' + s" @change="updateSecondLayerItems(f, s, $event, lang)"  type="text" class="form-control" v-model="first_layers[f].second_layers[s].name[lang]" v-bind:placeholder="$t('common.text_'+lang)"/>
                              <datalist :id="'name_second_layer_list_' + lang + '_' + f + '_' + s" v-if="first_layer_options.length > 0 && second_layer_options.length > 0">
                                <option v-for="second_option in second_layer_options" :key="second_option.sku" v-bind:value="second_option.name[lang]"  v-bind:label="second_option.name[lang]" ></option>
                              </datalist>
                            </b-form-group>
                            <div class="full-width d-flex">
                              <div class="size-label">{{$t('menu.code')}}</div>
                              <div class="size-code-input no-padding">
                                <b-form-input type="text" class="form-control" v-model="first_layers[f].second_layers[s].sku"/>
                              </div>
                            </div>
                            <div class="full-width d-flex mt-3" v-show="single.config.second_price">
                              <div class="flex-1" v-if="_.size(tier) <= 1 && single.config.second_multi_price != true && single.config.product_tax_price != true">
                                <div class="full-width" v-for="(price, p) in first_layers[f].second_layers[s].prices" :key="price.id">
                                  <input type="hidden" class="form-control" v-model="first_layers[f].second_layers[s].prices[p].active"/>
                                  <input type="hidden" class="form-control" v-model="first_layers[f].second_layers[s].prices[p].from"/>
                                  <input type="hidden" class="form-control" v-model="first_layers[f].second_layers[s].prices[p].to"/>
                                  <input type="hidden" class="form-control" v-model="first_layers[f].second_layers[s].prices[p].tax_rate"/>
                                  <div v-for="(name, index) in tier" class="full-width">
                                    <b-form-input type="number" min="0" class="form-control" v-model="first_layers[f].second_layers[s].prices[p].price[index]" v-bind:placeholder="$t('menu.price')" :disabled="checkDisableByConfig('second', 'price')">
                                    </b-form-input>
                                    <input type="hidden" class="form-control" v-model="first_layers[f].second_layers[s].prices[p].price_without_tax[index]"/>
                                  </div>
                                </div>
                              </div>
                              <div class="flex-1" v-if="_.size(tier) > 1 || single.config.second_multi_price == true || single.config.product_tax_price == true">
                                <button type="button" class="btn bg-main border-radius-4px" @click="showModal('first_'+f+'_second_'+s)">{{$t('menu.edit_price')}}</button>
                              </div>
                              <div class="flex-1 pl-10px">

                              </div>
                            </div>
                            <b-modal :id="'first_'+f+'_second_'+s" centered :title="$t('menu.price')">
                              <div class="row" v-if="single.config.second_multi_price">
                                <div class="col-sm-12 mb-2 text-main">
                                  <span class="button-text" @click="addPriceToSingeSecond(f, s)"><i class="fa fa-plus"></i> {{$t('common.add')}}</span>
                                </div>
                              </div>

                              <div class="full-width" v-for="(price, p) in first_layers[f].second_layers[s].prices" :key="price.id">
                                <input type="hidden" class="form-control" v-model="first_layers[f].second_layers[s].prices[p].active"/>
                                <div class="row bg-secondary py-2 d-flex" v-if="single.config.second_multi_price">
                                  <div class="d-flex flex-1 px-3">
                                    <div class="size-label">{{$t('menu.from')}}</div>
                                    <div class="size-code-input">
                                      <masked-input
                                        type="text"
                                        name="date"
                                        class="form-control"
                                        v-model="first_layers[f].second_layers[s].prices[p].from"
                                        :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                        :guide="true"
                                        placeholderChar="_"
                                        :showMask="true"
                                        :keepCharPositions="true">
                                      </masked-input>
                                    </div>
                                  </div>
                                  <div class="d-flex flex-1 px-3">
                                    <div class="size-label text-right">{{$t('menu.to')}}</div>
                                    <div class="size-code-input">
                                      <masked-input
                                        type="text"
                                        name="date"
                                        class="form-control"
                                        v-model="first_layers[f].second_layers[s].prices[p].to"
                                        :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                        :guide="true"
                                        placeholderChar="_"
                                        :showMask="true"
                                        :keepCharPositions="true">
                                      </masked-input>
                                    </div>
                                  </div>
                                  <div class="auto-width px-3 button-text" v-if="single.config.second_multi_price">
                                    <i class="fa fa-trash-o text-main" @click="removePriceToSingeSecond(f, s, p)"></i>
                                  </div>
                                </div>

                                <div class="row py-2">
                                  <div class="col-sm-12" v-if="single.config.product_tax_price">
                                    <b-form-group v-bind:label="$t('menu.tax_rate')">
                                      <input type="number" class="form-control" v-model="first_layers[f].second_layers[s].prices[p].tax_rate"/>
                                    </b-form-group>
                                  </div>
                                  <div class="col-sm-6 d-flex mb-3" v-for="(name, index) in tier">
                                    <b-card class="pb-0" v-bind:title="name ? name : $t('menu.tier') + ' ' + index">
                                      <b-form-group>
                                        <b-row>
                                          <div class="col-sm-12">
                                            <b-form-group v-bind:label="$t('menu.price')">
                                              <b-form-input type="number" min="0" class="form-control" v-model="first_layers[f].second_layers[s].prices[p].price[index]" v-bind:placeholder="$t('menu.price')" :disabled="checkDisableByConfig('second', 'price')">
                                              </b-form-input>
                                            </b-form-group>
                                          </div>
                                          <div class="col-sm-12" v-if="single.config.product_tax_price">
                                            <b-form-group v-bind:label="$t('menu.price_without_tax')">
                                              <input type="number" class="form-control" v-model="first_layers[f].second_layers[s].prices[p].price_without_tax[index]"/>
                                            </b-form-group>
                                          </div>

                                        </b-row>
                                      </b-form-group>
                                    </b-card>
                                  </div>
                                </div>
                              </div>
                              <div slot="modal-footer" class="full-width">
                                <button type="button" class="btn bg-main float-right border-radius-4px" v-on:click="hideModal('first_'+f+'_second_'+s)">{{$t('common.save')}}</button>
                              </div>
                            </b-modal>
                          </div>
                        </div>
                      </draggable>
                    </div>
                  </b-collapse>
                </div>
              </draggable>
            </b-form>
          </b-col>
        </b-row>
        <div slot="footer">
          <button type="button" class="btn border-radius-4px bg-main float-left ml-4" @click="$router.back()"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
          <div class="btn-save">
            <button class="btn bg-main border-radius-4px btn-main pl-3 pr-3" v-on:click="updateItem()" v-if="!processing">{{$t('common.save')}}</button>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<style scoped>
  .menu-option .switch.switch-icon{
    margin-top: 5px;
  }

  .ghost {
    opacity: 0.5;
  }
  .list-first {
    cursor: move;
  }
  .list-second {
    cursor: move;
  }

  .menu-option .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .menu-option .header-custom-switch .col-form-label{
    text-align: right;
  }

  .menu-option .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .menu-option .header-custom-switch .uppercase .first{
    margin-right: 10px;
  }

  .menu-option .header-custom-switch .uppercase .last{
    margin-left: 10px;
  }
  .option-first input:disabled {
    background-color: #cccccc;
  }
</style>

<style>
  .close-btn {
    font-size: 20px;
    cursor: pointer;
    float: right;
  }
  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .menu-option .card,
  .menu-option .card header.card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  .menu-option .card .card-body {
    padding-top: 0px;
  }
  .menu-option input {
    border-radius: 4px;
  }
  .size-label {
    width: auto;
    padding-right: 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
  }
  .size-name-input {
    flex: 1;
    padding-left: 5px;
    padding-right: 5px;
  }
  .size-code-input {
    flex: 1;
    padding-left: 5px;
    padding-right: 5px;
  }
  .size-price-input {
    flex: 1;
    padding-left: 5px;
    padding-right: 5px;
  }
  .size-active {
    padding-top: 5px;
    text-align: center;
  }
  .size-remove {
    text-align: center;
    font-size: 20px;
    line-height: 35px;
    cursor: pointer;
  }
  .option-first {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background: #e1e6eb;
    padding: 20px;
  }
  .second-box {
    background: #fff;
    border-radius: 4px;
    border: 1px solid #ccc;
    padding: 15px;
    margin-bottom: 15px;
  }
  .option-second {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    background: #f5f7f9;
    padding: 20px 15px 0 15px;
  }
  .second-header {
    line-height: 30px;
  }
  .option-box {
    padding-bottom: 15px;
  }
  .menu-option .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .menu-option .btn-save{
    float: right;
    margin-right: 22px;
  }
  .adjustment-padding-5 {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }
</style>
<script>
import cSwitch from '../../../components/Switch'
import vSelect from 'vue-select'
import MaskedInput from 'vue-text-mask'
import Draggable from 'vuedraggable'
let vm = null
const defaultDateFrom = '01-01-2008'
const defaultDateTo = '31-12-9999'

export default {
  name: 'MenuOption',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    cSwitch,
    vSelect,
    MaskedInput,
    Draggable
  },
  data: function () {
    return {
      enabled: true,
      processing: false,
      tier: this.$store.getters.config.main.tiers,
      single: this.$store.getters.config.gms.menu,
      item: this.$session.get('single') == null ? {} : this.$session.get('single'),
      first_layers: [],
      default_topping_ids: [],
      extra_topping_ids: [],
      default_topping_key: '',
      extra_topping_key: '',
      default_toppings: {},
      extra_toppings: {},
      first_layer_options: [],
      second_layer_options: [],
      groupSizeShow: []
    }
  },
  methods: {
    updateGroupSizeShow(event, i) {
      let vm = this
      vm.groupSizeShow[i] = !vm.groupSizeShow[i]
      this.$forceUpdate('groupSizeShow[' + i + ']')
    },
    sortData() {
      const sortData = JSON.parse(JSON.stringify(this.first_layers))
      sortData.sort(function(a, b){return a.sequence - b.sequence});

      sortData.map((first) => {
        return first.second_layers.sort( function(x, z) {return x.sequence - z.sequence})
      })

      return sortData
    },
    checkShowByConfig (layer, key) {
      if (this.single == null) {
        return true
      }
      let config = this._.find(this.single[layer], function (o) {
        return o.type === key
      })
      if (config == null) {
        return false
      }
      return config.show
    },
    checkDisableByConfig (layer, key) {
      if (this.item.content_status == 75) {
        return true
      }
      if (this.single == null) {
        return false
      }
      let config = this._.find(this.single[layer], {type: key})
      if (config == null) {
        return false
      }
      return config.disable
    },
    showModal (el) {
      this.$root.$emit('bv::show::modal', el)
    },
    hideModal (el) {
      this.$root.$emit('bv::hide::modal', el)
    },
    getReverseIndex (array, index) {
      return this._.size(array) - index - 1
    },
    getFirstReverseIndex (first) {
      return this.getReverseIndex(vm.first_layers, first)
    },
    getFirstPriceReverseIndex (first, price) {
      return this.getReverseIndex(vm.first_layers[this.getReverseIndex(vm.first_layers, first)].prices, price)
    },
    getFirstPriceWithoutTaxReverseIndex (first, price_without_tax) {
      return this.getReverseIndex(vm.first_layers[this.getReverseIndex(vm.first_layers, first)].prices, price_without_tax)
    },
    getSecondReverseIndex (first, second) {
      return this.getReverseIndex(vm.first_layers[this.getReverseIndex(vm.first_layers, first)].second_layers, second)
    },
    getSecondPriceReverseIndex (first, second, price) {
      return this.getReverseIndex(vm.first_layers[this.getReverseIndex(vm.first_layers, first)].second_layers[this.getReverseIndex(vm.first_layers[this.getReverseIndex(vm.first_layers, first)].second_layers, second)].prices, price)
    },
    getSecondPriceWithoutTaxReverseIndex (first, second, price_without_tax) {
      return this.getReverseIndex(vm.first_layers[this.getReverseIndex(vm.first_layers, first)].second_layers[this.getReverseIndex(vm.first_layers[this.getReverseIndex(vm.first_layers, first)].second_layers, second)].prices, price_without_tax)
    },
    /**
     * remove single second layer from list by index
     * @param first index and second index
     */
    removeSingeSecond (first, second) {
      let layers = []

      for (let i in this.first_layers[first].second_layers) {
        if (i != second) {
          layers.push(this.first_layers[first].second_layers[i])
        }
      }

      this.first_layers[first].second_layers = layers
    },
    /**
     * remove first layer from list by index
     * @param first index
     */
    removeSingeFirst (first) {
      let layers = []

      for (let i in this.first_layers) {
        if (i != first) {
          layers.push(this.first_layers[i])
        }
      }
      this.first_layers = layers
      if (vm.first_layers.length <= 0) {
        vm.processing = true
      }
    },
    /**
     * remove price of single layer from list by index
     * @param first index and price index
     */
    removePriceToSingeFirst (first, index) {
      let prices = []

      for (let i in this.first_layers[first].prices) {
        if (i != index) {
          prices.push(this.first_layers[first].prices[i])
        }
      }

      this.first_layers[first].prices = prices
    },
    /**
     * remove price of second layer from list by index
     * @param first index, second index and price index
     */
    removePriceToSingeSecond (first, second, index) {
      let prices = []

      for (let i in this.first_layers[first].second_layers[second].prices) {
        if (i != index) {
          prices.push(this.first_layers[first].second_layers[second].prices[i])
        }
      }

      this.first_layers[first].second_layers[second].prices = prices
    },
    /**
     * add second layer to list
     * @param first index
     */
    addSingleSecond (first) {
      let lang = {}
      vm.groupSizeShow[first] = true
      for (let l in this.$store.getters.languages) {
        lang[this.$store.getters.languages[l]] = ''
      }
      let price = {}
      let price_without_tax = {}
      let prices = []
      for (let t in vm.tier) {
        price[t] = (vm.single.config.price_by_tier ? undefined : 0),
        price_without_tax[t] = (vm.single.config.price_by_tier ? undefined : 0)
      }
      prices.push({
        from: defaultDateFrom,
        to: defaultDateTo,
        price: price,
        price_without_tax: price_without_tax,
        tax_rate: 0,
        active: 1
      })
      this.first_layers[first].second_layers.push({
        name: lang,
        prices: prices,
        special_dates: [],
        opening_times: [],
        sku: '',
        image: {},
        active: 1
      })
    },
    /**
     * add first layer to list
     */
    addSingleFirst () {
      let lang = {}
      for (let l in vm.$store.getters.languages) {
        lang[vm.$store.getters.languages[l]] = ''
      }

      let price = {}
      let price_without_tax = {}
      let prices = []
      for (let t in vm.tier) {
        price[t] = (vm.single.config.price_by_tier ? undefined : 0),
        price_without_tax[t] = (vm.single.config.price_by_tier ? undefined : 0)
      }
      prices.push({
        from: defaultDateFrom,
        to: defaultDateTo,
        price: price,
        price_without_tax: price_without_tax,
        tax_rate: 0,
        active: 1
      })
      vm.first_layers.push({
        name: lang,
        prices: prices,
        special_dates: [],
        opening_times: [],
        second_layers: [],
        sku: '',
        image: {},
        active: 1
      })
      vm.processing = false
    },
    /**
     * add price of first layer to list
     * @param first index
     */
    addPriceToSingeFirst (first) {
      let prices = {}
      let price_without_tax = {}
      for (let t in vm.tier) {
        prices[t] = (vm.single.config.price_by_tier ? undefined : 0),
        price_without_tax[t] = (vm.single.config.price_by_tier ? undefined : 0)
      }
      vm.first_layers[first].prices.push({
        from: defaultDateFrom,
        to: defaultDateTo,
        price: prices,
        price_without_tax: price_without_tax,
        tax_rate: 0,
        active: 1
      })
    },
    /**
     * add price of second layer to list
     * @param first index and second index
     */
    addPriceToSingeSecond (first, second) {
      let prices = {}
      let price_without_tax = {}
      for (let t in vm.tier) {
        prices[t] = (vm.single.config.price_by_tier ? undefined : 0),
        price_without_tax[t] = (vm.single.config.price_by_tier ? undefined : 0)
      }
      this.first_layers[first].second_layers[second].prices.push({
        from: defaultDateFrom,
        to: defaultDateTo,
        price: prices,
        price_without_tax: price_without_tax,
        tax_rate: 0,
        active: 1
      })
    },
    /**
     * convert data then save to local store then move to next form
     */
    updateItem () {
      let dataF = this._.cloneDeep(vm.first_layers)
      let firstLayers = []
      for (let f in dataF) {
        let singleFirstLayer = vm._.cloneDeep(dataF[f])

        for (let p in singleFirstLayer.prices) {
          singleFirstLayer.prices[p].from = vm.revertDateFormat(singleFirstLayer.prices[p].from) + ' 00:00:00'
          singleFirstLayer.prices[p].to = vm.revertDateFormat(singleFirstLayer.prices[p].to) + ' 23:59:59'
          singleFirstLayer.prices[p].price = vm.removePropertiesNotExistObject(Object.assign({}, singleFirstLayer.prices[p].price), Object.keys(vm.tier))
          singleFirstLayer.prices[p].price_without_tax = vm.removePropertiesNotExistObject(Object.assign({}, singleFirstLayer.prices[p].price_without_tax), Object.keys(vm.tier))
        }

        for (let s in singleFirstLayer.second_layers) {
          for (let p in singleFirstLayer.second_layers[s].prices) {
            singleFirstLayer.second_layers[s].prices[p].from = vm.revertDateFormat(singleFirstLayer.second_layers[s].prices[p].from) + ' 00:00:00'
            singleFirstLayer.second_layers[s].prices[p].to = vm.revertDateFormat(singleFirstLayer.second_layers[s].prices[p].to) + ' 23:59:59'
            singleFirstLayer.second_layers[s].prices[p].price = vm.removePropertiesNotExistObject(Object.assign({}, singleFirstLayer.second_layers[s].prices[p].price), Object.keys(vm.tier))
            singleFirstLayer.second_layers[s].prices[p].price_without_tax = vm.removePropertiesNotExistObject(Object.assign({}, singleFirstLayer.second_layers[s].prices[p].price_without_tax), Object.keys(vm.tier))
          }
        }
        firstLayers.push(singleFirstLayer)
      }
      
      // set sequence
      firstLayers.map((first,indexFirst) => {
        first.sequence = indexFirst;
        return first.second_layers.map((second,indexSecond) => {
          second.sequence = indexSecond
          return second;
        })
      })
      vm.item.first_layers = this._.cloneDeep(firstLayers)
      vm.$session.set('single', vm.item)
      var uuid = vm.id
      vm.processing = true
      vm.axios.updateMenuLayer({uuid: vm.id, first_layers: firstLayers}, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        vm.processing = false
        // vm.$router.push({name: 'menu_available', params: { uuid }})
      }, function () {
        vm.processing = false
      })
    },
    /**
     * convert date from YYYY-MM-DD to DD-MM-YYYY
     * @param val
     * @returns {*}
     */
    convertDateFormat (val) {
      return this.$moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY')
    },
    /**
     * revert date from DD-MM-YYYY to YYYY-MM-DD
     * @param val
     * @returns {*}
     */
    revertDateFormat (val) {
      return this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')
    },
    getFirstLayerOptions() {
      let params = 'active=1&limit=9999'
      vm.axios.menu.getFirstLayerList(params, function (response) {
        vm.first_layer_options = response.data.data.items
      })
    },
    getSecondLayerOptions() {
      let params = 'active=1&limit=9999'
      vm.axios.menu.getSecondLayerList(params, function (response) {
        vm.second_layer_options = response.data.data.items
      })
    },
    updateFirstLayerItems (index, event, lang) {
      let first_layer

      if (lang === undefined) {
        first_layer = this.first_layer_options.find(f => f.sku === event)
      } else {
        first_layer = this.first_layer_options.find(f => f.name[lang] === event)
      }

      if (first_layer) {
        for (let i in vm.$store.getters.languages) {
          if (vm.$store.getters.languages.hasOwnProperty(i)) {
            vm.first_layers[index].name[vm.$store.getters.languages[i]] = first_layer.name[vm.$store.getters.languages[i]]
          }
        }
        vm.first_layers[index].sku = first_layer.sku
        vm.first_layers[index].first_id = first_layer.id
        vm.first_layers[index].short_name = first_layer.short_name
      }
    },
    updateSecondLayerItems (indexFirstLayer, indexSecondLayer, event, lang) {
      let second_layer
      if (lang === undefined) {
        second_layer = vm.second_layer_options.find(s => s.sku === event)
      } else {
        second_layer = vm.second_layer_options.find(s => s.name[lang] === event)
      }

      if (second_layer) {
        for (let i in vm.$store.getters.languages) {
          if (vm.$store.getters.languages.hasOwnProperty(i)) {
            vm.first_layers[indexFirstLayer].second_layers[indexSecondLayer].name[vm.$store.getters.languages[i]] = second_layer.name[vm.$store.getters.languages[i]]
          }
        }
        vm.first_layers[indexFirstLayer].second_layers[indexSecondLayer].sku = second_layer.sku
        vm.first_layers[indexFirstLayer].second_layers[indexSecondLayer].second_id = second_layer.id
        vm.first_layers[indexFirstLayer].second_layers[indexSecondLayer].short_name = second_layer.short_name
      }
    },
  },
  created: function () {
    vm = this
    vm.getFirstLayerOptions()
    vm.getSecondLayerOptions()
    if (vm.item == null) {
      vm.axios.getMenuDetail(vm.id,
        function (response) {
          vm.item = response.data.data.item
          for (let i in vm.images) {
            vm.imageData[vm.images[i]] = vm.item.image[vm.images[i]] != null ? vm.item.image[vm.images[i]] : ''
          }
          if (vm.item.opening_times == null || vm.item.opening_times.length <= 0) {
            let days = []
            for (let i in vm.daysOfWeek) {
              days[vm.daysOfWeek[i]] = {
                opening: '08:00:00',
                closing: '23:00:00',
                active: 1
              }
            }
            vm.opening_times = days
          } else {
            vm.opening_times = vm.item.opening_times
          }
          if (vm.item.special_dates == null) {
            vm.special_dates = []
          } else {
            vm.special_dates = vm.item.special_dates
          }
          vm.first_layers = vm.item.first_layers
          for (let f in vm.first_layers) {
            for (let p in vm.first_layers[f].prices) {
              vm.first_layers[f].prices[p].from = vm.convertDateFormat(vm.first_layers[f].prices[p].from)
              vm.first_layers[f].prices[p].to = vm.convertDateFormat(vm.first_layers[f].prices[p].to)
              vm.first_layers[f].prices[p].price_without_tax = vm.first_layers[f].prices[p].price_without_tax != null ? vm.first_layers[f].prices[p].price_without_tax : []
            }
            for (let s in vm.first_layers[f].second_layers) {
              for (let p in vm.first_layers[f].second_layers[s].prices) {
                vm.first_layers[f].second_layers[s].prices[p].from = vm.convertDateFormat(vm.first_layers[f].second_layers[s].prices[p].from)
                vm.first_layers[f].second_layers[s].prices[p].to = vm.convertDateFormat(vm.first_layers[f].second_layers[s].prices[p].to)
                vm.first_layers[f].second_layers[s].prices[p].price_without_tax = vm.first_layers[f].second_layers[s].prices[p].price_without_tax != null ? vm.first_layers[f].second_layers[s].prices[p].price_without_tax : []
              }
            }
          }
          vm.first_layers = vm.sortData()
        })
      vm.$session.set('single', vm.item)
    } else {
      vm.first_layers = vm.item.first_layers

      for (let f in vm.first_layers) {
        if (vm.first_layers[f].prices.length > 0) {
          for (let p in vm.first_layers[f].prices) {
            vm.first_layers[f].prices[p].from = vm.convertDateFormat(vm.first_layers[f].prices[p].from)
            vm.first_layers[f].prices[p].to = vm.convertDateFormat(vm.first_layers[f].prices[p].to)
            vm.first_layers[f].prices[p].price_without_tax = vm.first_layers[f].prices[p].price_without_tax != null ? vm.first_layers[f].prices[p].price_without_tax : []
          }
        } else {
          vm.addPriceToSingeFirst(f)
        }

        for (let s in vm.first_layers[f].second_layers) {
          if (vm.first_layers[f].second_layers[s].prices.length > 0) {
            for (let p in vm.first_layers[f].second_layers[s].prices) {
              vm.first_layers[f].second_layers[s].prices[p].from = vm.convertDateFormat(vm.first_layers[f].second_layers[s].prices[p].from)
              vm.first_layers[f].second_layers[s].prices[p].to = vm.convertDateFormat(vm.first_layers[f].second_layers[s].prices[p].to)
              vm.first_layers[f].second_layers[s].prices[p].price_without_tax = vm.first_layers[f].second_layers[s].prices[p].price_without_tax != null ? vm.first_layers[f].second_layers[s].prices[p].price_without_tax : []
            }
          } else {
            vm.addPriceToSingeSecond(f, s)
          }
        }
      }
      vm.first_layers = vm.sortData()
    }

    if (vm.first_layers.length <= 0) {
      vm.processing = true
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/admin/menu/OptionForm.vue